import { ROLE_TYPES } from '../../utils/DataConstants';
import {
	quotesSubcontractorRestCrudThunks,
	quotesRestCrudThunksForBuyer,
	quotesRestCrudThunksForSupplier,
	quotesContractorRestCrudThunks,
} from '../../thunks/quotes_thunks';
import {
	isContractor,
	nullSafeGet,
	nullSafeGetOrElse,
	recordHasContractorId,
} from '../../utils/DataAccessUtils';
import { getSanitisedQuote } from '../../utils/WorkOrderUtils';
import { SupplierFacilityName } from '../name_component/supplierFacility/supplierFacilityNameComponent';
import React from 'react';
import { BuyerCompanyName } from '../name_component/buyerCompany/buyerCompanyNameComponent';
import { isBuyerOrInternalTech } from '../../utils/AuthUtils';

export const isClientQuoteViewLocation = (location) =>
	!nullSafeGetOrElse('pathname', location, '').includes('contractor');

export const isSubcontractorQuoteViewLocation = (location) =>
	nullSafeGetOrElse('pathname', location, '').includes('subcontractor');

export const getQuoteSubURL = (userType, currentUser, record) => {
	const hasContractorId = recordHasContractorId(record);
	const isClientView = !isContractor(currentUser, record);
	return userType === ROLE_TYPES.SUPPLIER
		? hasContractorId
			? isClientView
				? 'supplier/quotes/contractor'
				: 'supplier/quotes/subcontractor'
			: 'supplier/quotes'
		: 'buyer/quotes';
};

export const getQuotePathNameBackButton = (userType, currentUser, record, toIndexPage) => {
	const hasContractorId = recordHasContractorId(record);
	const isClientView = !isContractor(currentUser, record);
	return userType === ROLE_TYPES.SUPPLIER
		? hasContractorId
			? isClientView
				? toIndexPage
					? 'supplier/quotes'
					: 'supplier/quotes/contractor'
				: 'supplier/quotes/subcontractor'
			: 'supplier/quotes'
		: 'buyer/quotes';
};

export const getQuoteSubAPIURL = (userType, currentUser, record) => {
	const hasContractorId = recordHasContractorId(record);
	const isClientView = !isContractor(currentUser, record);
	return userType === ROLE_TYPES.SUPPLIER
		? hasContractorId
			? isClientView
				? 'supplier/quote/contractor_proposals'
				: 'supplier/quote/subcontractor_proposals'
			: 'supplier/quote/proposals'
		: 'buyer/quote/proposals';
};

export const getQuoteRestCrudThunksFromPath = (userType, location) =>
	userType === ROLE_TYPES.BUYER
		? quotesRestCrudThunksForBuyer
		: nullSafeGetOrElse('pathname', location, '').includes('supplier/quotes/contractor')
		? quotesContractorRestCrudThunks
		: nullSafeGetOrElse('pathname', location, '').includes('supplier/quotes/subcontractor')
		? quotesSubcontractorRestCrudThunks
		: quotesRestCrudThunksForSupplier;

export const getQuoteRestCrudThunksContractorId = (
	userType,
	hasContractorId,
	isClientView = false
) =>
	userType === ROLE_TYPES.SUPPLIER
		? hasContractorId
			? isClientView
				? quotesContractorRestCrudThunks
				: quotesSubcontractorRestCrudThunks
			: quotesRestCrudThunksForSupplier
		: quotesRestCrudThunksForBuyer;

export const isClientQuoteView = (quote, currentUser) => {
	if (quote.subSupplierFacilityId === undefined) return true;
	return quote.subSupplierFacilityId === nullSafeGet('facility.id', currentUser);
};

export const getQuoteOtherCompanyEntity = (proposal, currentUser) => {
	const quote = getSanitisedQuote(proposal);
	const isContractorWorkOrder = recordHasContractorId(quote);
	if (isBuyerOrInternalTech(currentUser)) {
		return nullSafeGet('supplierFacility', quote);
	} else if (isContractorWorkOrder) {
		if (isClientQuoteView(quote, currentUser)) {
			return nullSafeGet('contractorSupplierFacility', quote);
		} else {
			return nullSafeGet('subSupplierFacility', quote);
		}
	} else {
		return nullSafeGet('workOrder.buyerCompany', quote);
	}
};

export const getQuoteOtherCompany = (proposal, currentUser) => {
	if (!(proposal && proposal.id)) return null; //quote is undefined
	const quote = getSanitisedQuote(proposal);
	const isContractorWorkOrder = recordHasContractorId(quote);
	if (isBuyerOrInternalTech(currentUser)) {
		//Return normal third party supplier
		return (
			<SupplierFacilityName
				facility={nullSafeGet('supplierFacility', quote)}
				mode={'card'}
				placement={'top'}
				allowHover={false}
			/>
		);
	} else if (isContractorWorkOrder) {
		if (isClientQuoteView(quote, currentUser)) {
			return (
				<SupplierFacilityName
					facility={nullSafeGet('contractorSupplierFacility', quote)}
					mode={'card'}
					placement={'top'}
					allowHover={false}
				/>
			);
		} else {
			return (
				<SupplierFacilityName
					facility={nullSafeGet('subSupplierFacility', quote)}
					mode={'card'}
					placement={'top'}
					allowHover={false}
				/>
			);
		}
	} else {
		return (
			<BuyerCompanyName
				company={nullSafeGet('workOrder.buyerCompany', quote)}
				mode={'card'}
				placement={'top'}
				allowHover={false}
			/>
		);
	}
};
